import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { CargoResponse } from './cargo.model';

@Injectable({ providedIn: 'root' })
export class CargoService extends BaseService {
    private readonly BASE = environment.basePath + '/sistema/registro/cargo';

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    listar(): Observable<CargoResponse[]> {
        return this.http.get<CargoResponse[]>(this.BASE);
    }
}
